import { FC, SVGProps } from 'react';

export const TextIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<g id='Group 1160442953'>
			<path
				id='Vector (Stroke)'
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0.5 2.61806C0.5 1.4224 1.46927 0.453125 2.66493 0.453125H13.1163C14.312 0.453125 15.2812 1.4224 15.2812 2.61806V13.0694C15.2812 14.2651 14.312 15.2344 13.1163 15.2344H2.66493C1.46928 15.2344 0.5 14.2651 0.5 13.0694V2.61806ZM2.66493 1.79688C2.2114 1.79688 1.84375 2.16453 1.84375 2.61806V13.0694C1.84375 13.523 2.2114 13.8906 2.66493 13.8906H13.1163C13.5699 13.8906 13.9375 13.523 13.9375 13.0694V2.61806C13.9375 2.16452 13.5699 1.79688 13.1163 1.79688H2.66493Z'
				fill='currentColor'
			/>
			<path
				id='Vector (Stroke)_2'
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3.48633 4.11133C3.48633 3.74026 3.78714 3.43945 4.1582 3.43945H11.6235C11.9945 3.43945 12.2954 3.74026 12.2954 4.11133C12.2954 4.48239 11.9945 4.7832 11.6235 4.7832H4.1582C3.78714 4.7832 3.48633 4.48239 3.48633 4.11133Z'
				fill='currentColor'
			/>
			<path
				id='Vector (Stroke)_3'
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3.48633 7.84375C3.48633 7.47268 3.78714 7.17188 4.1582 7.17188H11.6235C11.9945 7.17188 12.2954 7.47268 12.2954 7.84375C12.2954 8.21482 11.9945 8.51563 11.6235 8.51563H4.1582C3.78714 8.51563 3.48633 8.21482 3.48633 7.84375Z'
				fill='currentColor'
			/>
			<path
				id='Vector (Stroke)_4'
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3.48633 11.5762C3.48633 11.2051 3.78714 10.9043 4.1582 10.9043H8.63737C9.00844 10.9043 9.30924 11.2051 9.30924 11.5762C9.30924 11.9472 9.00844 12.248 8.63737 12.248H4.1582C3.78714 12.248 3.48633 11.9472 3.48633 11.5762Z'
				fill='currentColor'
			/>
		</g>
	</svg>
);
